import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { LocationStrategy, HashLocationStrategy, registerLocaleData } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import localES from '@angular/common/locales/es-PE';
registerLocaleData(localES);
import { RecaptchaModule } from 'ng-recaptcha';
import { ROUTES } from './app.routes';
import { AppComponent } from './app.component';
import { AppviewsModule } from './views/appviews/appviews.module';
import { EnvServiceProvider } from '../environments/env.service.provider';
import { ConsultaEstadoModule } from './modules/consultaestado/consultaestado.module';
// import { OnlyNumberDirective } from './components/directives/number.directive';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      resetTimeoutOnDuplicate: true
    }),
    SweetAlert2Module.forRoot(),
    RecaptchaModule,
    // Routes
    RouterModule.forRoot(ROUTES, {onSameUrlNavigation: 'reload'}),
    AppviewsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ConsultaEstadoModule
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy},
    { provide: LOCALE_ID, useValue: 'es-PE' },
    Title, EnvServiceProvider ],
  bootstrap: [AppComponent]
})
export class AppModule { }
